export default "__VITE_ASSET__CtCmijQG__"